export default __webpack_public_path__ + "static/js/pdf.worker.7f8f2dcc.js";